export const intervalMapping = {
  HOUR_HALF: '1/2 Hour',
  HOUR_ONE: '1 Hour',
  HOUR_TWO: '2 Hour',
  HOUR_THREE: '3 Hour',
  HOUR_FOUR: '4 Hour',
  HOUR_EIGHT: '8 Hour',
  HOUR_TWELVE: '12 Hour',
  HOUR_TWENTY_FOUR: '24 Hour',
};
